module.exports = __webpack_public_path__ + "img/broadband.3b575d5.svg";